import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _sum from "lodash/sum";
var _class;
import { Collection } from 'core/model/Collection';
import { computed } from 'mobx';
import { numberWithCommas } from 'app/util/utils';
import SiteModel from './SiteModel';
let SiteCollection = (_class = class SiteCollection extends Collection {
  get url() {
    return '/api/ui/sites';
  }
  get model() {
    return SiteModel;
  }
  get defaultSortState() {
    return {
      field: 'title',
      direction: 'asc'
    };
  }
  get filterFieldWhitelist() {
    return new Set(['id', 'title', 'address', 'city', 'region', 'country', 'postal', 'countryName', 'type']);
  }
  get totalCost() {
    return _sum(this.models.map(site => site.totalCost));
  }
  get totalCostFormatted() {
    return `$${numberWithCommas(this.totalCost)}`;
  }
}, _applyDecoratedDescriptor(_class.prototype, "totalCost", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalCost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalCostFormatted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalCostFormatted"), _class.prototype), _class);
export default SiteCollection;